/* soraflo-push: 2026-07-09T05:33:04.826Z */
/**
 * Vehicle Fitment Filter — SoraFlo
 *
 * Builds searchable custom dropdowns (nice-select style) over the hidden
 * native <select> elements rendered by the Liquid section.  No jQuery or
 * external libraries required.
 */

(function () {
  "use strict";

  var SEARCH_MIN = 15; // show search box when options exceed this count (matches data-search-min-items="15")

  // ── SVG helpers ────────────────────────────────────────────────────────────

  function carSvg() {
    var ns  = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("class",           "vff-mobile-trigger-icon");
    svg.setAttribute("viewBox",         "0 0 512 512");
    svg.setAttribute("width",           "18");
    svg.setAttribute("height",          "18");
    svg.setAttribute("fill",            "none");
    svg.setAttribute("stroke",          "currentColor");
    svg.setAttribute("stroke-width",    "32");
    svg.setAttribute("stroke-linecap",  "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden",     "true");
    var body = document.createElementNS(ns, "path");
    body.setAttribute("d", "M80 224l37.78-88.15C123.93 121.5 139.6 112 157.11 112h197.78c17.51 0 33.18 9.5 39.33 23.85L432 224M80 224h352v144H80zM112 368v32H80v-32M432 368v32h-32v-32");
    var w1 = document.createElementNS(ns, "circle");
    w1.setAttribute("cx", "144"); w1.setAttribute("cy", "288"); w1.setAttribute("r", "16");
    var w2 = document.createElementNS(ns, "circle");
    w2.setAttribute("cx", "368"); w2.setAttribute("cy", "288"); w2.setAttribute("r", "16");
    svg.appendChild(body);
    svg.appendChild(w1);
    svg.appendChild(w2);
    return svg;
  }

  function caretSvg() {
    var ns  = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("class", "vff-caret");
    svg.setAttribute("viewBox", "0 0 512 512");
    svg.setAttribute("width", "14");
    svg.setAttribute("height", "14");
    svg.setAttribute("aria-hidden", "true");
    var p = document.createElementNS(ns, "path");
    p.setAttribute("d", "M112 184l144 144 144-144");
    p.setAttribute("fill", "none");
    p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "48");
    p.setAttribute("stroke-linecap", "round");
    p.setAttribute("stroke-linejoin", "round");
    svg.appendChild(p);
    return svg;
  }

  // ── Build one custom dropdown ──────────────────────────────────────────────
  //
  // Hides the native <select>, inserts a .vff-nice-select wrapper after it,
  // and returns a state object used by the rest of the widget.

  function buildNiceSelect(nativeSel, placeholder) {
    // Hide but keep in DOM (accessible, no layout impact)
    nativeSel.style.cssText =
      "position:absolute;opacity:0;pointer-events:none;width:0;height:0;overflow:hidden;";

    var wrapper = document.createElement("div");
    wrapper.className = "vff-nice-select vff-disabled";
    wrapper.setAttribute("tabindex", "0");
    wrapper.setAttribute("role", "combobox");
    wrapper.setAttribute("aria-expanded", "false");
    wrapper.setAttribute("aria-haspopup", "listbox");

    var current = document.createElement("span");
    current.className = "vff-current";
    current.textContent = placeholder;

    var dropdown = document.createElement("div");
    dropdown.className = "vff-dropdown";
    dropdown.setAttribute("role", "listbox");

    var searchBox = document.createElement("div");
    searchBox.className = "vff-search-box";
    var searchInput = document.createElement("input");
    searchInput.type = "text";
    searchInput.className = "vff-search";
    searchInput.placeholder = "Search\u2026";
    searchInput.setAttribute("autocomplete", "off");
    searchInput.setAttribute("spellcheck", "false");
    searchBox.appendChild(searchInput);

    var list = document.createElement("ul");
    list.className = "vff-list";
    list.setAttribute("role", "listbox");

    dropdown.appendChild(searchBox);
    dropdown.appendChild(list);

    wrapper.appendChild(current);
    wrapper.appendChild(caretSvg());
    wrapper.appendChild(dropdown);

    nativeSel.parentNode.insertBefore(wrapper, nativeSel.nextSibling);

    return {
      nativeSel:   nativeSel,
      wrapper:     wrapper,
      current:     current,
      searchBox:   searchBox,
      searchInput: searchInput,
      list:        list,
      placeholder: placeholder,
      value:       "",
      options:     [],     // current option values
      isOpen:      false,
    };
  }

  // ── Populate a custom dropdown ─────────────────────────────────────────────

  function populateNS(ns, values) {
    ns.options  = values || [];
    ns.value    = "";
    ns.current.textContent = ns.placeholder;
    ns.current.classList.remove("vff-has-value");

    // Show/hide search box based on option count
    ns.searchBox.style.display = ns.options.length > SEARCH_MIN ? "" : "none";
    ns.searchInput.value = "";

    renderList(ns, "");

    // Enable / disable wrapper
    if (ns.options.length === 0) {
      ns.wrapper.classList.add("vff-disabled");
    } else {
      ns.wrapper.classList.remove("vff-disabled");
    }
  }

  function renderList(ns, query) {
    var q   = query.toLowerCase().trim();
    var frag = document.createDocumentFragment();

    ns.options.forEach(function (val) {
      if (q && val.toLowerCase().indexOf(q) === -1) return;
      var li = document.createElement("li");
      li.className  = "vff-option" + (val === ns.value ? " vff-selected" : "");
      li.setAttribute("data-value", val);
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", val === ns.value ? "true" : "false");
      li.textContent = val;
      frag.appendChild(li);
    });

    ns.list.innerHTML = "";
    ns.list.appendChild(frag);
  }

  // ── Open / close ───────────────────────────────────────────────────────────

  function openNS(ns, allInstances) {
    // Close all others first
    allInstances.forEach(function (other) {
      if (other !== ns) closeNS(other);
    });
    ns.isOpen = true;
    ns.wrapper.classList.add("vff-open");
    ns.wrapper.setAttribute("aria-expanded", "true");
    ns.searchInput.value = "";
    renderList(ns, "");
    // Focus search if visible
    if (ns.searchBox.style.display !== "none") {
      setTimeout(function () { ns.searchInput.focus(); }, 10);
    }
  }

  function closeNS(ns) {
    ns.isOpen = false;
    ns.wrapper.classList.remove("vff-open");
    ns.wrapper.setAttribute("aria-expanded", "false");
    ns.searchInput.value = "";
    renderList(ns, "");
  }

  function disableNS(ns) {
    closeNS(ns);
    ns.wrapper.classList.add("vff-disabled");
    populateNS(ns, []);
  }

  // ── Select a value ─────────────────────────────────────────────────────────

  function selectValue(ns, value) {
    ns.value = value;
    ns.current.textContent = value || ns.placeholder;
    if (value) {
      ns.current.classList.add("vff-has-value");
    } else {
      ns.current.classList.remove("vff-has-value");
    }
    renderList(ns, ns.searchInput.value);
  }

  // ── Init one .vff-root element ─────────────────────────────────────────────

  function init(root) {
    // Remove any nice-selects built by a previous init() call on this root.
    // This handles Shopify theme-editor section reloads (shopify:section:load)
    // which can trigger init() multiple times on the same element.
    root.querySelectorAll(".vff-nice-select").forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    // Remove mobile trigger + panel header from a previous init() call
    root.querySelectorAll(".vff-mobile-trigger, .vff-panel-header, .vff-clear-btn").forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    // Remove any leftover backdrop appended to body
    document.querySelectorAll(".vff-mobile-backdrop").forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    root.classList.remove("vff-panel-open");
    document.body.style.overflow = "";
    // Restore native selects so buildNiceSelect() can hide them again cleanly
    root.querySelectorAll(".vff-select").forEach(function (sel) {
      sel.style.cssText = "";
    });

    var ds  = root.dataset;

    var apiBase       = (ds.apiBase       || "").replace(/\/$/, "");
    var shopDomain    = ds.shop            || "";
    var namespace     = ds.namespace       || "custom";
    var makeKey       = ds.makeKey         || "make";
    var modelKey      = ds.modelKey        || "model";
    var yearKey       = ds.yearKey         || "year";
    var makeParam     = ds.makeParam       || ("filter.p.m." + namespace + "." + makeKey);
    var modelParam    = ds.modelParam      || ("filter.p.m." + namespace + "." + modelKey);
    var yearParam     = ds.yearParam       || ("filter.p.m." + namespace + "." + yearKey);
    var collectionUrl = ds.collectionUrl   || "/collections/all";
    var loadingText   = ds.loadingText     || "Loading vehicle options\u2026";
    var resetText     = ds.resetText       || "Reset Vehicle";
    var panelTitleText  = ds.panelTitle      || "Select Vehicle";
    var triggerText     = ds.triggerText     || "Select Your Vehicle";

    var makeSel  = root.querySelector("[data-role='make']");
    var modelSel = root.querySelector("[data-role='model']");
    var yearSel  = root.querySelector("[data-role='year']");
    var submitBtn   = root.querySelector(".vff-submit");
    var status      = root.querySelector(".vff-status");
    var origBtnText = submitBtn
      ? (((submitBtn.querySelector(".vff-btn-text") || {}).textContent) || "Find Parts")
      : "Find Parts";

    if (!makeSel) return;

    var makePlaceholder  = (makeSel.options[0]              || {}).text || "Select Make";
    var modelPlaceholder = (modelSel && modelSel.options[0] ? modelSel.options[0].text : "Select Model");
    var yearPlaceholder  = (yearSel  && yearSel.options[0]  ? yearSel.options[0].text  : "Select Year");

    // Build custom dropdowns
    var makeNS  = buildNiceSelect(makeSel,  makePlaceholder);
    var modelNS = modelSel ? buildNiceSelect(modelSel, modelPlaceholder) : null;
    var yearNS  = yearSel  ? buildNiceSelect(yearSel,  yearPlaceholder)  : null;
    var allNS   = [makeNS, modelNS, yearNS].filter(Boolean);

    var allData = null;

    // ── Status helper ─────────────────────────────────────────────────────────

    function setStatus(msg, isError) {
      if (!status) return;
      status.textContent = msg;
      status.className = "vff-status" + (isError ? " vff-status--error" : "");
    }

    function updateSubmit() {
      if (!submitBtn) return;
      var hasVehicle = !!makeNS.value;
      submitBtn.disabled = !hasVehicle;
      var showReset = hasVehicle && isVehicleSaved;
      var textEl = submitBtn.querySelector(".vff-btn-text");
      if (textEl) textEl.textContent = showReset ? resetText : origBtnText;
      submitBtn.setAttribute("data-vff-mode", showReset ? "reset" : "find");
    }

    updateSubmit();

    // ── Cascading selection logic ──────────────────────────────────────────────

    function onMakeChange(make) {
      makeNS.value = make;
      if (modelNS) disableNS(modelNS);
      if (yearNS)  disableNS(yearNS);

      if (make && allData) {
        if (modelNS) {
          var modelList = (allData.models || {})[make] || [];
          populateNS(modelNS, modelList);
          // Auto-open the model dropdown once it's populated
          if (modelList.length > 0) openNS(modelNS, allNS);
        } else if (yearNS) {
          // No model dropdown — aggregate all years for this make
          var makeYears = new Set ? new Set() : { _d: {}, add: function(v){ this._d[v]=1; }, has: function(v){ return !!this._d[v]; } };
          Object.keys(allData.years || {}).forEach(function (k) {
            if (k.indexOf(make + "|||") === 0) {
              (allData.years[k] || []).forEach(function (y) { makeYears.add(y); });
            }
          });
          var sortedYears = typeof makeYears.values === "function"
            ? Array.from(makeYears.values()).sort()
            : Object.keys(makeYears._d).sort();
          populateNS(yearNS, sortedYears);
        }
      }

      updateSubmit();
    }

    function onModelChange(model) {
      if (!modelNS) return;
      modelNS.value = model;
      if (yearNS) disableNS(yearNS);

      if (model && allData && yearNS) {
        var yKey     = makeNS.value + "|||" + model;
        var yearList = (allData.years || {})[yKey] || [];
        populateNS(yearNS, yearList);
      }

      updateSubmit();
    }

    // ── Attach events to a nice-select instance ───────────────────────────────

    function attachEvents(ns, onSelect) {
      // Click on wrapper → toggle open
      ns.wrapper.addEventListener("click", function (e) {
        if (ns.wrapper.classList.contains("vff-disabled")) return;
        if (ns.isOpen) {
          closeNS(ns);
        } else {
          openNS(ns, allNS);
        }
        e.stopPropagation();
      });

      // Click on list option
      ns.list.addEventListener("click", function (e) {
        var li = e.target.closest ? e.target.closest(".vff-option") : e.target;
        if (!li || !li.classList.contains("vff-option")) return;
        e.stopPropagation();
        var val = li.getAttribute("data-value");
        selectValue(ns, val);
        closeNS(ns);
        onSelect(val);
      });

      // Search input
      ns.searchInput.addEventListener("input", function () {
        renderList(ns, ns.searchInput.value);
      });

      // Prevent search click from closing dropdown
      ns.searchInput.addEventListener("click", function (e) {
        e.stopPropagation();
      });

      // Keyboard: Escape closes; Enter/Space opens; arrows move focus
      ns.wrapper.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { closeNS(ns); ns.wrapper.focus(); }
        if ((e.key === "Enter" || e.key === " ") && !ns.isOpen) {
          openNS(ns, allNS);
          e.preventDefault();
        }
      });
    }

    // ── Trigger text helper (updated after every selection) ───────────────────
    var triggerTextEl  = null; // set by mobile panel builder below
    var resetBadgeEl   = null; // set by mobile panel builder below
    var isVehicleSaved = false; // true only when a saved vehicle is restored from localStorage

    function updateTriggerText() {
      if (!triggerTextEl) return;
      var label = (modelNS && modelNS.value) ? modelNS.value
                : (makeNS.value)             ? makeNS.value
                : "";
      triggerTextEl.textContent = label || triggerText;
      triggerTextEl.style.color = label ? "var(--vff-text)" : "";
    }

    // ── localStorage persistence ───────────────────────────────────────────────

    var storageKey = "vff_" + shopDomain + "_" + namespace;

    function updateClearBtn() {
      var btn = root.querySelector(".vff-clear-btn");
      if (btn) btn.style.display = makeNS.value ? "" : "none";
      if (resetBadgeEl) resetBadgeEl.style.display = (makeNS.value && isVehicleSaved) ? "inline-flex" : "none";
    }

    function dispatchVehicleChange(vehicle) {
      try {
        window.dispatchEvent(new CustomEvent("vff:vehicle-change", {
          detail: { storageKey: storageKey, vehicle: vehicle }
        }));
      } catch (e) {}
    }

    function clearVehicle() {
      isVehicleSaved = false;
      selectValue(makeNS, "");
      makeNS.value = "";
      if (modelNS) disableNS(modelNS);
      if (yearNS)  disableNS(yearNS);
      try { localStorage.removeItem(storageKey); } catch (e) {}
      updateSubmit();
      updateTriggerText();
      updateClearBtn();
      dispatchVehicleChange(null);
    }

    function saveVehicle() {
      var data = {
        make:       makeNS.value                    || "",
        model:      modelNS ? modelNS.value || "" : "",
        year:       yearNS  ? yearNS.value  || "" : "",
        makeParam:  makeParam,
        modelParam: modelParam,
        yearParam:  yearParam
      };
      try { localStorage.setItem(storageKey, JSON.stringify(data)); } catch (e) {}
      updateClearBtn();
      dispatchVehicleChange(data);
    }

    function loadVehicle() {
      try { return JSON.parse(localStorage.getItem(storageKey) || "null"); }
      catch (e) { return null; }
    }

    attachEvents(makeNS,  function (val) { isVehicleSaved = false; onMakeChange(val); updateTriggerText(); saveVehicle(); });
    if (modelNS) attachEvents(modelNS, function (val) { isVehicleSaved = false; onModelChange(val); updateTriggerText(); saveVehicle(); });
    if (yearNS)  attachEvents(yearNS,  function (val) { isVehicleSaved = false; yearNS.value = val; updateTriggerText(); saveVehicle(); });

    // ── Match button height to nice-select ────────────────────────────────────
    // CSS em/box-sizing can be overridden by theme stylesheets, so we measure
    // the rendered nice-select and set the button height directly in JS.

    function syncButtonHeight() {
      if (!submitBtn) return;
      var ref = makeNS.wrapper; // first nice-select as reference
      var h = ref.offsetHeight;
      if (h > 0) submitBtn.style.height = h + "px";
    }

    // Sync on load (after paint) and whenever the window is resized
    setTimeout(syncButtonHeight, 0);
    window.addEventListener("resize", syncButtonHeight);

    // ── Mobile panel (≤599 px) ─────────────────────────────────────────────────
    // On small screens the form is hidden; a trigger button opens a fixed overlay
    // panel containing the form (with a header and close button injected by JS).

    (function () {
      var svgNs = "http://www.w3.org/2000/svg";

      // ── Trigger button ──────────────────────────────────────────────────────
      var trigger     = document.createElement("button");
      trigger.type    = "button";
      trigger.className = "vff-mobile-trigger";
      var trigText    = document.createElement("span");
      trigText.className = "vff-mobile-trigger-text";
      trigText.textContent = triggerText;
      var trigCaret   = caretSvg();
      trigCaret.setAttribute("class", "vff-mobile-trigger-caret");
      var resetBadge = document.createElement("span");
      resetBadge.className = "vff-reset-badge";
      resetBadge.textContent = resetText;
      resetBadge.style.display = "none";
      resetBadge.addEventListener("click", function (e) {
        e.stopPropagation();
        clearVehicle();
      });

      trigger.appendChild(carSvg());
      trigger.appendChild(trigText);
      trigger.appendChild(trigCaret);
      trigger.appendChild(resetBadge);
      triggerTextEl = trigText; // wire up updateTriggerText()
      resetBadgeEl  = resetBadge; // wire up updateClearBtn()

      // ── Panel header (prepended inside .vff-form) ───────────────────────────
      var panelHdr    = document.createElement("div");
      panelHdr.className = "vff-panel-header";

      var panelTitle  = document.createElement("span");
      panelTitle.className   = "vff-panel-title";
      panelTitle.textContent = panelTitleText;

      var closeSvg = document.createElementNS(svgNs, "svg");
      closeSvg.setAttribute("viewBox", "0 0 24 24");
      closeSvg.setAttribute("width",   "18");
      closeSvg.setAttribute("height",  "18");
      closeSvg.setAttribute("fill",    "none");
      closeSvg.setAttribute("stroke",  "currentColor");
      closeSvg.setAttribute("stroke-width",    "2.5");
      closeSvg.setAttribute("stroke-linecap",  "round");
      closeSvg.setAttribute("stroke-linejoin", "round");
      closeSvg.setAttribute("aria-hidden",     "true");
      var l1 = document.createElementNS(svgNs, "line");
      l1.setAttribute("x1", "18"); l1.setAttribute("y1", "6");
      l1.setAttribute("x2", "6");  l1.setAttribute("y2", "18");
      var l2 = document.createElementNS(svgNs, "line");
      l2.setAttribute("x1", "6");  l2.setAttribute("y1", "6");
      l2.setAttribute("x2", "18"); l2.setAttribute("y2", "18");
      closeSvg.appendChild(l1);
      closeSvg.appendChild(l2);

      var closeBtn    = document.createElement("button");
      closeBtn.type   = "button";
      closeBtn.className = "vff-panel-close";
      closeBtn.setAttribute("aria-label", "Close");
      closeBtn.appendChild(closeSvg);

      panelHdr.appendChild(panelTitle);
      panelHdr.appendChild(closeBtn);

      // ── Backdrop ────────────────────────────────────────────────────────────
      var backdrop    = document.createElement("div");
      backdrop.className = "vff-mobile-backdrop";
      document.body.appendChild(backdrop);

      // ── Wire into DOM ───────────────────────────────────────────────────────
      var panelForm = root.querySelector(".vff-form");
      if (panelForm) {
        // Trigger sits between heading/subheading and the form
        panelForm.parentNode.insertBefore(trigger, panelForm);
        // Header is the first child inside the form (visible only in panel)
        panelForm.insertBefore(panelHdr, panelForm.firstChild);
      }

      // ── Open / close ────────────────────────────────────────────────────────
      function openPanel() {
        root.classList.add("vff-panel-open");
        backdrop.classList.add("vff-panel-open");
        document.body.style.overflow = "hidden";
        setTimeout(syncButtonHeight, 50); // re-measure after panel renders
      }

      function closePanel() {
        root.classList.remove("vff-panel-open");
        backdrop.classList.remove("vff-panel-open");
        document.body.style.overflow = "";
      }

      trigger.addEventListener("click",  openPanel);
      closeBtn.addEventListener("click", closePanel);
      backdrop.addEventListener("click", closePanel);

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && root.classList.contains("vff-panel-open")) closePanel();
      });

      // Close panel if viewport grows beyond mobile breakpoint (e.g. rotation)
      window.addEventListener("resize", function () {
        if (window.innerWidth >= 600) closePanel();
      });
    }());

    // ── Clear selection button ─────────────────────────────────────────────────

    var clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "vff-clear-btn";
    clearBtn.textContent = "Clear selection";
    clearBtn.style.display = "none"; // shown by updateClearBtn when selection exists

    clearBtn.addEventListener("click", function () {
      clearVehicle();
    });

    var statusEl = root.querySelector(".vff-status");
    if (statusEl && statusEl.parentNode) {
      statusEl.parentNode.insertBefore(clearBtn, statusEl.nextSibling);
    }
    updateClearBtn();

    // ── Close on outside click ─────────────────────────────────────────────────

    document.addEventListener("click", function () {
      allNS.forEach(closeNS);
    });

    // ── Form submit ────────────────────────────────────────────────────────────

    var form = root.querySelector(".vff-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (submitBtn && submitBtn.getAttribute("data-vff-mode") === "reset") {
          clearVehicle();
          return;
        }
        var make  = makeNS.value;
        var model = modelNS ? modelNS.value : "";
        var year  = yearNS  ? yearNS.value  : "";
        if (!make) return;
        var params = new URLSearchParams();
        params.set(makeParam, make);
        // Always include Universal fitment products in results
        if (make !== "Universal") params.append(makeParam, "Universal");
        if (model) params.set(modelParam, model);
        if (year)  params.set(yearParam,  year);
        // Include any extra hidden inputs (e.g. product type filter)
        var extraInputs = form.querySelectorAll("input[type='hidden']");
        for (var xi = 0; xi < extraInputs.length; xi++) {
          var inp = extraInputs[xi];
          if (inp.name && inp.value &&
              inp.name !== makeParam && inp.name !== modelParam && inp.name !== yearParam) {
            params.set(inp.name, inp.value);
          }
        }
        window.location.href = collectionUrl + "?" + params.toString();
      });
    }

    // ── Fetch options from API ─────────────────────────────────────────────────

    if (!apiBase || !shopDomain) {
      setStatus("Vehicle filter not configured — check block settings.", true);
      return;
    }

    setStatus(loadingText);

    var url = apiBase + "/api/public/fitment/options"
      + "?shop="      + encodeURIComponent(shopDomain)
      + "&namespace=" + encodeURIComponent(namespace)
      + "&makeKey="   + encodeURIComponent(makeKey)
      + "&modelKey="  + encodeURIComponent(modelKey)
      + "&yearKey="   + encodeURIComponent(yearKey);

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error("API " + r.status);
        return r.json();
      })
      .then(function (data) {
        allData = data;
        setStatus("");
        var makes = (data.makes || []).filter(function (m) {
          return m.toLowerCase() !== "universal";
        });
        populateNS(makeNS, makes);
        updateSubmit();

        // ── Restore previously saved vehicle ──────────────────────────────────
        var saved = loadVehicle();
        if (saved && saved.make && makes.indexOf(saved.make) !== -1) {
          selectValue(makeNS, saved.make);
          makeNS.value = saved.make;

          if (modelNS) {
            var modelList = (data.models || {})[saved.make] || [];
            if (modelList.length) {
              populateNS(modelNS, modelList);
              if (saved.model && modelList.indexOf(saved.model) !== -1) {
                selectValue(modelNS, saved.model);
                modelNS.value = saved.model;
                if (yearNS) {
                  var yKey = saved.make + "|||" + saved.model;
                  var yearList = (data.years || {})[yKey] || [];
                  if (yearList.length) {
                    populateNS(yearNS, yearList);
                    if (saved.year && yearList.indexOf(String(saved.year)) !== -1) {
                      selectValue(yearNS, String(saved.year));
                      yearNS.value = String(saved.year);
                    }
                  }
                }
              }
            }
          } else if (yearNS) {
            var makeYears = {};
            Object.keys(data.years || {}).forEach(function (k) {
              if (k.indexOf(saved.make + "|||") === 0) {
                (data.years[k] || []).forEach(function (y) { makeYears[String(y)] = 1; });
              }
            });
            var sortedYears = Object.keys(makeYears).sort();
            if (sortedYears.length) {
              populateNS(yearNS, sortedYears);
              if (saved.year && makeYears[String(saved.year)]) {
                selectValue(yearNS, String(saved.year));
                yearNS.value = String(saved.year);
              }
            }
          }

          isVehicleSaved = true;
          updateSubmit();
          updateTriggerText();
          updateClearBtn();
        }
      })
      .catch(function (err) {
        setStatus("Could not load vehicle options. Please refresh.", true);
        console.error("[VFF]", err);
      });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────

  function boot() {
    document.querySelectorAll(".vff-root").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:block:select", function (e) { init(e.target); });
    document.addEventListener("shopify:section:load", boot);
  }
})();
